import { Injectable } from '@angular/core';
import { MenuItem } from '../shell/shell/menu-item';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  constructor(private authService: AuthenticationService) { }

  public getMenuItems(): MenuItem[] {
    const items: MenuItem[] = [];
    if (this.authService.getUserRole() !== null) {
      items.push({
        title: 'My Details',
        route: '/users/my-details',
        icon: 'person'
      });
    }
    else{
      items.push({
        title: 'Login',
        route: '/login',
        icon: 'verified_user'
      });  
      items.push({
        title: 'Register',
        route: '/register',
        icon: 'assignment'
      });  
      items.push({
        title: 'Terms And Conditions',
        route: '/terms',
        icon: 'playlist_add_check'
      });    
      items.push({
        title: 'Contact us',
        route: '/contact',
        icon: 'contact_support'
      });   
      items.push({
        title: 'Prices 2024',
        route: '/prices',
        icon: 'attach_money'
      });   
      items.push({
        title: 'Events',
        route: '/events',
        icon: 'calendar_today'
      });      
    }

    if (this.authService.getUserRole() === 'Administrator') {
      items.push({
        title: 'Users',
        route: '/users',
        icon: 'people'
      });
      items.push({
        title: 'Bulk Email',
        route: '/bulk-email',
        icon: 'email'
      });
      items.push({
        title: 'Events',
        route: '/events',
        icon: 'calendar_today'
      });


    }
    return items;
  }
}
